import React, { useState } from 'react';
import { Box, Modal, Typography, TextField, Button } from '@mui/material';
import { TOKENS } from '../state/colors';
import { fs } from '../state/typography';
import { BolsaCentro } from '../types';

interface ManualSendModalProps {
  bolsa: BolsaCentro;
  onCerrar: () => void;
  onConfirmar: (nota: string) => void;
}

// SPEC-180 UC-003/CA-003 — vía manual: nota opcional, sin PDF ni versión
export const ManualSendModal: React.FC<ManualSendModalProps> = ({ bolsa, onCerrar, onConfirmar }) => {
  const [nota, setNota] = useState('');

  return (
    <Modal open onClose={onCerrar} data-testid="manual-send-modal">
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 440,
          maxWidth: '92vw',
          backgroundColor: '#fff',
          borderRadius: '20px',
          padding: '30px 32px',
          boxShadow: '0 24px 60px rgba(46,36,48,.28)',
        }}
      >
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(11), fontWeight: 600, letterSpacing: '2.2px', textTransform: 'uppercase', color: TOKENS.muted, marginBottom: '6px' }}>
          ENVÍO MANUAL
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(19), fontWeight: 700, color: TOKENS.ink, marginBottom: '6px' }}>
          {bolsa.codigo_cotizacion ?? bolsa.id} → {bolsa.cliente_razon_social ?? 'cliente'}
        </Typography>
        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(12.5), color: TOKENS.muted, marginBottom: '18px' }}>
          Se marcará como ENVIADA sin generar versión ni PDF — úsalo cuando ya la enviaste por fuera del sistema.
        </Typography>

        <Typography sx={{ fontFamily: 'Poppins, sans-serif', fontSize: fs(11), fontWeight: 600, textTransform: 'uppercase', color: TOKENS.muted, marginBottom: '4px' }}>
          NOTA (OPCIONAL)
        </Typography>
        <TextField
          data-testid="manual-send-nota"
          fullWidth
          multiline
          minRows={3}
          placeholder="Ej: enviada por WhatsApp el 09/09"
          value={nota}
          onChange={(e) => setNota(e.target.value)}
          sx={{ marginBottom: '20px' }}
        />

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <Button onClick={onCerrar} sx={{ textTransform: 'none', fontFamily: 'Poppins, sans-serif', border: `1px solid ${TOKENS.hair}`, color: TOKENS.text }}>
            Cancelar
          </Button>
          <Button
            data-testid="manual-send-confirm"
            onClick={() => onConfirmar(nota)}
            sx={{
              textTransform: 'none',
              fontFamily: 'Poppins, sans-serif',
              backgroundColor: TOKENS.purple,
              color: '#fff',
              borderRadius: '999px',
              padding: '8px 20px',
              '&:hover': { backgroundColor: TOKENS.purpleDark },
            }}
          >
            Marcar como enviada
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
